/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};

(function () {
  'use strict';

  app.helpers.UrlHelper = {

    /**
     * Исключенные параметры
     */
    excludedParams: ['viewtype', 'sort', 'per-page'],

    /**
     * Получает все параметры из URL.
     *
     * @param {string|undefined} [url], если не указан, то берётся url текущей страницы
     *
     * @returns {object} {} объект с гет параметрами запроса.
     */
    getUrlParameters: function (url) {
      if (!url) {
        url = location.href;
      }
      var pageURL = url.split('?'),
        pageURLRemovedHash = pageURL.length > 1 ? pageURL[1].split('#')[0] : '',
        getParams = pageURLRemovedHash.split('&');
      return getParams.reduce(function (acc, cur) {
          var arr = cur.split('='),
            key = arr[0] ? arr[0] : '',
            value = arr[1] ? arr[1] : '';

          try {
            value = decodeURIComponent(value);
          } catch (e) {
            value = '';
          }
          if (key && value) {
            acc[key] = value;
          }
          return acc;
        }, {});
    },
    /**
     * Возвращает текущее значение GET параметра.
     *
     * @param {string} sParam Параметр, значение которого нужно узнать.
     * @param {string} [url] Опционально, URL, из которого будут парсится параметр, если не передан,
     * то параметры будут выделены из текущего URL страницы
     *
     * @returns {*}
     */
    getUrlParameter: function (sParam, url) {
      var params = this.getUrlParameters(url);
      if (params[sParam] !== undefined) {
        // энкодим для доступности ввода амперсанда (&) и других символов в поисковой запрос
        if (sParam === 'q') {
          return encodeURIComponent(params[sParam]);
        }
        return params[sParam];
      }
    },

    /**
     * Формирует нужные GET параметры из урл в строку для новой ссылки.
     *
     * @param params Массив параметров, которые нужно добавить к ссылке. Например, ['currency', 'page']
     *
     * @returns {string} Строка вида 'currency=USD&page=2'
     */
    getExistParamString: function (params) {
      var result = [],
        i;
      for (i in params) {
        if (params.hasOwnProperty(i) && this.getUrlParameter(params[i])) {
          result.push(params[i] + '=' + this.getUrlParameter(params[i]));
        }
      }
      return result.join('&');
    },

    /**
     * Формирует GET параметры.
     *
     * @param {object} params Объект параметров, которые нужно добавить к ссылке. Например, {'currency': 1, 'page': 2}
     *
     * @returns {string} Строка вида 'currency=1&page=2'
     */
    getParamString: function (params) {
      var result = [],
        i;
      for (i in params) {
        if (params.hasOwnProperty(i)) {
          result.push(i + '=' + params[i]);
        }
      }
      return result.join('&');
    },

    /**
     * Формирует ссылку с нужными GET параметрами.
     *
     * @param url Адрес ссылки.
     * @param existParams Массив параметров, которые нужно добавить к ссылке из адресной строки.
     * @param params Массив параметров, которые нужно добавить к ссылке.
     * @param exclude Исключать параметры из url описанные в excludedParams
     *
     * @returns {string} Сформированная ссылка с GET параметрами.
     */
    to: function (url, existParams, params, exclude) {
      if(typeof exclude === 'undefined'){
        exclude = true;
      }
      if (exclude && typeof params !== 'undefined') {
        for (var i in params) {
          if (params.hasOwnProperty(i) && this.excludedParams.indexOf(i) > 0) {
            delete params[i];
          }
        }
      }
      var existParamString = this.getExistParamString(existParams);
      var paramString = this.getParamString(params);

      if (url[url.length - 1] !== '/') {
        url = url + '/';
      }

      if (paramString || existParamString) {
        url = url + '?';
      }

      if (paramString) {
        url = url + paramString;
      }

      if (existParamString) {
        if (url[url.length - 1] !== '?') {
          url = url + '&';
        }
        url = url + existParamString;
      }
      return url;
    },

    /**
     * Получаем основной домен
     * @param {string} [hostname] Полный домен с поддоменами
     * @returns {string} Основной домен.
     */
    getDomain: function (hostname) {
      if (!hostname) {
        hostname = location.hostname;
      }
      var parts = hostname.split('.');
      if (parts.length > 2) {
        parts = parts.slice(-2);
      }
      return parts.join('.');
    },
    /**
     * Получаем pathname
     * @return {string}  Текущий pathname
     */
    getPathname: function () {
      return location.pathname;
    },
    /**
     * Возвращает отфильтрованные GET параметры.
     * @param {Array} exclude Исключенные параметры. Также доступно частичное совпадение.
     * @param {String} [url=location.href] URL для фильтрации.
     * @returns {Object} Отфильтрованные параметры
     */
    getFilteredUrlParameters: function (exclude, url) {
      exclude = exclude || [];
      var params = this.getUrlParameters(url);
      if (exclude.length) {
        var filter = [];
        exclude.forEach(function (exclusion) {
          _.keys(params).forEach(function (param) {
            if (_.includes(param, exclusion)) {
              filter.push(param);
            }
          });
        });
        return _.omit(params, filter);
      } else {
        return params;
      }
    }
  };

})();

}.call(window));